import { render } from "./AbtestsRequest.vue?vue&type=template&id=44d699de&bindings={\"id\":\"props\",\"group\":\"props\",\"abtest\":\"data\",\"isLoading\":\"data\",\"fetchData\":\"options\",\"save\":\"options\"}"
import script from "./AbtestsRequest.vue?vue&type=script&lang=js"
export * from "./AbtestsRequest.vue?vue&type=script&lang=js"
script.render = render

export default script